import PropTypes from 'prop-types';
import React from 'react';
import { CSVLink } from 'react-csv';
import { bitacoraApi } from 'src/api/modules/bitacora';
import CustomButton from 'src/common/components/CustomButton';

const ExportCSV = ({
	data = [],
	columns = [],
	fileName = '',
	label = 'Descargar CSV',
	className = '',
	disabled = false,
}) => {
	const filterColumns = () => {
		// Get column names
		let headers = [];
		columns.forEach((col, idx) => {
			if (col.text !== 'Acciones') headers.push(col.text);
		});

		return headers;
	};
	const filterData = () => {
		// Get column names
		let headers = [];
		columns.forEach((col, idx) => {
			if (col.text !== 'Acciones') headers.push(col.dataField);
		});
		return headers;
	};

	const dat = data.map((element) => {
		let array = [];
		filterData().forEach((columns) => {
			if (typeof element[columns] === 'object') {
				const newArray = element[columns]
					.map((element) => element.nombre)
					.join(',');
				array.push(newArray || '');
			} else {
				array.push(element[columns] || '');
			}
		});
		return array;
	});

	const log = () => {
		let validateExtension = fileName.slice(fileName.lastIndexOf('.') - 1 + 2);
		bitacoraApi.post({
			accion:
				validateExtension === 'csv'
					? 'Descargo CSV ' + fileName
					: 'Descargo excel ' + fileName,
		});
	};

	return (
		<CustomButton
			className={className}
			disabled={disabled}
			color="info"
			onClick={() => {
				log();
			}}
			mainText={
				<CSVLink
					data={dat}
					headers={filterColumns()}
					filename={fileName.split(' ').join('_')}
					className="text-reset"
				>
					{label}
				</CSVLink>
			}
		/>
	);
};

ExportCSV.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired,
	fileName: PropTypes.string.isRequired,
};

export default ExportCSV;
